import React from 'react';
import { IconButton, Typography } from '@mui/material';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
  const handleFirstPage = () => {}//onPageChange(1);
  const handleLastPage = () => {} //onPageChange(totalPages);
  const handlePrevPage = () => {} //onPageChange(Math.max(1, currentPage - 1));
  const handleNextPage = () => {} //onPageChange(Math.min(totalPages, currentPage + 1));

  return (
    <div style={{ display: 'flex', alignItems: 'right' }}>
      <IconButton onClick={handleFirstPage} disabled={currentPage === 1} style={{ width: '15px' }}>
        <FirstPageIcon />
      </IconButton>
      <IconButton onClick={handlePrevPage} disabled={currentPage === 1} style={{ width: '15px' }}>
        <ChevronLeftIcon />
      </IconButton>
      <Typography variant="body1" style={{ margin: '0px' }} className='content-center'>
        {/* {currentPage} */}
        1
      </Typography>
      <IconButton onClick={handleNextPage} disabled={currentPage === totalPages} style={{ width: '15px' }}>
        <ChevronRightIcon />
      </IconButton>
      <IconButton onClick={handleLastPage} disabled={currentPage === totalPages} style={{ width: '15px' }}>
        <LastPageIcon />
      </IconButton>
    </div>
  );
};

export default CustomPagination;
